<app-loader-indicator></app-loader-indicator>
<div class="privacy-policy" [innerHTML]="htmlContent"></div>
